import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const StakeholderProfileLink = ({
  projectId,
  stakeholderId,
  ...props
}) => (
  <Link
    route="projects/stakeholders/show"
    params={{ projectId, stakeholderId, slug: getOrgSlug() }}
    {...props}
  />
);

export const EditStakeholderLink = ({ projectId, stakeholderId, ...props }) => (
  <AuthorizedAction action="update" subject="stakeholder">
    <Link
      route="projects/stakeholders/edit/step-stakeholder"
      params={{ projectId, stakeholderId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const StakeholdersSettingsLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="update" subject="stakeholder">
    <Link
      route="projects/stakeholders/settings"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const AddOrgStakeholderLink = ({ ...props }) => (
  <AuthorizedAction action="update" subject="organizationStakeholder">
    <Link
      route="organization/stakeholders/new"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const ChangeStrategySettingsLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="update" subject="stakeholder">
    <Link
      route="projects/change-strategy/settings"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);
